'use strict';

import {
  createHtmlElement,
  findSelectionAndCrmData,
  getCurrentDateTime,
  getUrlParam,
  isCurrentDateWithinRange
} from '../../../functions';
import {changeLangToCurrent, getCurrentLang} from "../langSwitcher/langSwitcher";
import {analytics} from "../../analytics/analytics";
import { getProps, releasePayment } from '../../crm/crm-requests';
import {UnitCardClass} from "../../cards/unitCards/UnitCardClass";
import {selectionBoxesSetStatusColor} from "../../threejs/raycast";
import { isMobile, projectMode, settingsData } from '../../../settings';
import {searchGetResults} from "../../menu/search/search";
import { DreamsPreloader } from '../preloader/DreamsPreloader';

let paymentUID = null;

export class Prepayment {
  constructor (parent, crm, position) {
    const APISettings = config.crmProjectSettings.prepayment;
    const isWithingDateRange = isCurrentDateWithinRange(APISettings?.utcStartTime, APISettings?.utcEndTime, getCurrentDateTime('YYYY-MM-DD HH:MM', 'UTC'))
    const isAPIPermits = isWithingDateRange && APISettings?.active === 1;
    const isUrlParam = parseInt(getUrlParam('prepayment')) === 1;
    const isActive = isUrlParam || isAPIPermits;
    if (crm.engineId.match(/patio/g) || !isActive)
      return;

    this.parent = parent;
    this.crm = crm;
    this.position = position;
    this.preloader = null;
    this.reserved = false;

    if (this.crm.status !== 'Available' && this.crm.status !== 'InSaving')
      return;

    this.#addButton();
    if (this.crm.status === 'InSaving')
      this.button.disabled = true;
  }

  static disable(prop) {
    const currentButton = document.getElementById('prepayment');
    if (!currentButton)
      return;

    if (prop.engineId === currentButton.getAttribute('engineId'))
      currentButton.disabled = true;
  }

  static enable(prop) {
    const currentButton = document.getElementById('prepayment');
    if (!currentButton)
      return;

    if (prop.engineId === currentButton.getAttribute('engineId'))
      currentButton.disabled = false;
  }

  #addButton() {
    if (this.position) {
      this.button = createHtmlElement('','','button',['customer-contact-now-btn', 'prepayment-btn','language-string']);
      this.parent.insertAdjacentElement(this.position,this.button);
    } else {
      this.button = createHtmlElement(this.parent,'','button',['customer-contact-now-btn', 'prepayment-btn','language-string']);
    }

    this.button.type = 'button';
    this.button.setAttribute('id','prepayment');
    this.button.setAttribute('engineId', this.crm.engineId);

    if (this.reserved) {
      this.button.innerText = changeLangToCurrent('Reserved');
      this.button.setAttribute('data-dictionary', 'Reserved');
      this.button.classList.add('reserved');
    } else {
      this.button.classList.add('button');
      this.button.innerText = changeLangToCurrent('Make Prepayment');
      this.button.setAttribute('data-dictionary', 'Make Prepayment');
      this.button.addEventListener('click', this.#listener.bind(this));
    }
  }

  #listener(e) {
    e.stopPropagation();

    if (this.reserved) return;

    this.#createPrepayment();
    analytics('prepayment',this.crm)
  }

  #createPrepayment() {
    this.prepaymentContainer = createHtmlElement(document.body,'','div',['prepayment-container']);
    this.iframeContainer = createHtmlElement(this.prepaymentContainer,'','div',['prepayment-container__iframe-container']);

    this.#addPreloader(this.iframeContainer);

    const closeBtn = createHtmlElement(this.iframeContainer,'','button',['prepayment__close-btn','icon-close']);
    const iframe = createHtmlElement(this.iframeContainer,'','iframe',['prepayment-iframe']);
    let url =`https://mbeat.bmby.com/PaymentGateWay/NewWizard/${getCurrentLang()}/?prop_id=${this.crm.bmbyPropID}&project_id=${config.projectGuid}`;
    const clientId = getUrlParam('clientId');
    if (clientId) {
      url += `&i=${clientId}`;
    }
    iframe.src = url;

    closeBtn.addEventListener('click', this.#closeListener.bind(this));

    iframe.onload = () => this.#removePreloader();
  }

  async #closeListener() {

    this.#addPreloader(this.iframeContainer,'prepayment__preloader-opacity');

    const paymentData = {
      action: 'closed',
      propId: this.crm.bmbyPropID
    };

    if (paymentUID) {
      paymentData.uid = paymentUID;
    }

    await releasePayment(paymentData);
    const newCrmData = await getProps();
    const data = newCrmData.data;
    const newAptStatus = data.find(apt => apt.bmbyPropID === this.crm.bmbyPropID).status;
    const searchList = document.querySelector('.search__container-bottom');

    if (newAptStatus !== this.crm.status) {
      this.crm.status = newAptStatus;

      if (!isMobile) {
        const card = new UnitCardClass(this.crm);
        UnitCardClass.closeMultipleCards();
        UnitCardClass.cards.push(card);
        card.createCard();
      }

      const { selectedMesh } = findSelectionAndCrmData(this.crm.engineId);
      selectedMesh.userData.isActive = false;
      selectedMesh.userData.isClicked = true;
      selectionBoxesSetStatusColor(selectedMesh,'click');
      this.button.remove();
      const secondBtn = document.querySelector('.prepayment-btn');
      secondBtn && secondBtn.remove();

      this.reserved = true;

      const optionCard = document.querySelector('.options-card');
      if (optionCard) {
        optionCard.classList.add('unavailable');

        const optionCardPriceBlock = optionCard.querySelector('.options-card__price');
        if (optionCardPriceBlock) {
          optionCardPriceBlock.classList.add('language-string');
          optionCardPriceBlock.innerHTML = changeLangToCurrent(newAptStatus);
          optionCardPriceBlock.setAttribute('data-dictionary', newAptStatus);
          optionCardPriceBlock.classList.remove('hide-price-field');
        }

        const favorite = optionCard.querySelector('.options-card__favorite');
        favorite?.remove();
      }
    } else {
      const { selectedMesh } = findSelectionAndCrmData(this.crm.engineId);
      selectedMesh.userData.isActive = true;
      selectedMesh.userData.isInSearch = true;
      selectedMesh.userData.isClicked = true;
      selectionBoxesSetStatusColor(selectedMesh,'click');
    }

    // Update all apartments
    data.forEach(apt => {
      if (apt.engineId !== this.crm.engineId) {
        const oldData = settingsData.allCrmData.find(crm => crm.engineId === apt.engineId);
        if (oldData)
          oldData.status = apt.status;
      }
    });

    if (searchList)
      searchGetResults();

    this.#removePreloader();
    this.#closePrepayment();
  }

  #addPreloader(parent,customClass) {
    this.preloader = new DreamsPreloader(parent,customClass)
        .absolute()
        .show();
  }

  #removePreloader() {
    this.preloader && this.preloader.remove();
    this.preloader = null;
  }

  #closePrepayment() {
    this.prepaymentContainer.remove();
  }
}


window.addEventListener("message", (e) => {
   if (e && typeof e.data === 'object') {
     if (e.data.paymentUID) {
       paymentUID = e.data.paymentUID;
     } else if (e.data.buildingId) {
       const buildingName = config.buildings.find(building => building.buildingId === e.data.buildingId)?.buildingEngineId;
       if (buildingName) {
         projectMode.Cylinder.switchBuilding(buildingName, false, true);
       }
     }
   }
});
